import React, { useState, useEffect } from 'react'
import styled from 'styled-components'

// components
import Paging from '../../../components/pagination/Paging'
import DropDown from '../../../components/dropdown/DropDown'
import Loading from '../../../components/atom/loading/Loading'

// styles
import colors from '../../../styles/colors'

// images
import DownloadImg from '../../../assets/image/download/ic-green-download.svg'

const TABLE_HEADER_ITEM = [
  '주문번호',
  '주문유형',
  '상세유형',
  '주문상태',
  '주문일시',
  '배달/픽업요청',
  '취소/완료일시',
  '브랜드명',
  '매장명',
  '배달대행사',
  '상품명',
  '수량',
  '판매금액',
]

const TABLE_BODY_ITEM = Array.from(Array(50).keys())

function Table({ loading, item, size, setSize, page, setPage, handleExcel }) {
  const [tableSize, setTableSize] = useState(10)
  const [tableItem, setTableItem] = useState([])
  const [currentPage, setCurrentPage] = useState(1)

  // dummy test
  useEffect(() => {
    // 체크 아이템 데이터
    if (TABLE_BODY_ITEM) {
      getSliceTableItem(currentPage)
    }
  }, [currentPage])

  // dummy test
  useEffect(() => {
    // 현재 페이지 넘버가 마지막 페이지 넘버보다 큰 경우 강제로 페이지 변경
    if (Math.ceil(TABLE_BODY_ITEM.length / tableSize) < currentPage) {
      changePage(Math.ceil(TABLE_BODY_ITEM.length / tableSize))
    }
    // 페이지는 그대로
    // 테이블 개수만 변경
    else {
      getSliceTableItem(currentPage)
    }
  }, [tableSize])

  // dummy test
  const getSliceTableItem = (page) => {
    setTableItem(
      TABLE_BODY_ITEM.slice((page - 1) * 10, (page - 1) * 10 + tableSize),
    )
  }

  const changePage = (page) => {
    setPage(page)
  }

  return (
    <Container>
      {loading && <Loading />}

      <TitleWrapper>
        <ExcelTitle onClick={handleExcel}>
          <img src={DownloadImg} />
          <span>엑셀 다운로드</span>
        </ExcelTitle>
        <SelectTitle>
          <DropDown
            options={[10, 20, 50]}
            setOption={setSize}
            value={size}
            isPageUnit={true}
          />
        </SelectTitle>
      </TitleWrapper>
      <TableWrapper>
        <TableHeader>
          {TABLE_HEADER_ITEM.map((item, idx) => (
            <li key={idx}>{item}</li>
          ))}
        </TableHeader>

        {item.list &&
          item.list.map((ele, idx) => (
            <TableBody key={idx}>
              <li>{ele.orderNum}</li>
              <li>{ele.orderType}</li>
              <li>{ele.orderStatus}</li>
              <li>{ele.orderDetail}</li>
              {/* <li>{getDetailType(ele.detailType)}</li> */}
              <li>{ele.orderDateTime}</li>
              <li>{ele.pickupDateTime}</li>
              <li>{ele.completeDate}</li>
              <li>{ele.brandname}</li>
              <li>{ele.storeName}</li>
              <li>{ele?.deliveryName ?? ''}</li>
              <li>{ele.goodsName}</li>
              <li>{ele.totalEa}</li>
              <li>{`${Number(ele.price).toLocaleString()}원`}</li>
            </TableBody>
          ))}

        <Paging
          page={page}
          count={item.total}
          setPage={(e) => changePage(e)}
          isTemp={true}
          tableSize={size}
          marginTop={[40, 17]}
        />
      </TableWrapper>
    </Container>
  )
}

export default Table

const Container = styled.div`
  width: 100%;
  max-width: 768px;
  min-width: 320px;

  display: flex;
  flex-direction: column;
  position: relative;

  padding-top: 30px;

  .pagination {
    position: absolute;
  }
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 16px;

  @media ${(props) => props.theme.mobile} {
    justify-content: space-between;
    margin-bottom: 26px;
  }
`

const ExcelTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }

  span {
    color: ${colors.mainG};
    font-size: 16px;
    margin-top: 4px;

    @media ${(props) => props.theme.mobile} {
      font-size: 14px;
    }
  }
`

const SelectTitle = styled.div`
  margin-left: 35px;

  .dropdown {
    flex: 1;
    margin-bottom: 0px !important;

    .show {
      /* width: 95%; */

      @media ${(props) => props.theme.mobile} {
        font-size: 14px;
      }
    }

    button {
      width: 162px;

      @media ${(props) => props.theme.mobile} {
        width: 125px;
        font-size: 14px;
      }
    }
  }
`

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 70px;

  @media ${(props) => props.theme.mobile} {
    padding-bottom: 63px;
  }

  /* scroll */
  width: 100%;
  overflow-x: scroll;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: ${colors.G2};
  }

  &::-webkit-scrollbar-track {
    border: 1px solid ${colors.G2};
  }
`

const TableHeader = styled.div`
  display: flex;

  li {
    /* scroll */
    display: flex;
    height: 50px;
    justify-content: center;
    align-items: center;
    border-right: 1px solid ${colors.G5};
    border-bottom: 1px solid ${colors.G5};
    background-color: ${colors.W4};
    color: ${colors.G4};
    font-size: 14px;

    @media ${(props) => props.theme.mobile} {
      height: 33px;
      font-size: 8px;

      border-right: 0px solid ${colors.G5};
    }

    :nth-child(1) {
      min-width: 140px;

      @media ${(props) => props.theme.mobile} {
        border-right: 1px solid ${colors.G5};
      }
    }

    :nth-child(n + 2):nth-child(-n + 4) {
      min-width: 94px;
    }

    :nth-child(n + 5):nth-child(-n + 7) {
      min-width: 140px;
    }

    :nth-child(8) {
      min-width: 102px;
    }

    :nth-child(9) {
      min-width: 99px;
    }

    :nth-child(10) {
      min-width: 113px;
    }

    :nth-child(11) {
      min-width: 151px;
    }

    :nth-child(12) {
      min-width: 58px;
    }

    :nth-child(13) {
      min-width: 100px;
    }
  }

  li:nth-last-child(1) {
    border-right: 0px solid ${colors.mainG};
  }
`

const TableBody = styled.div`
  display: flex;

  li {
    /* scroll */
    /* flex: 1; */
    /* height: 56px; */
    display: flex;
    justify-content: center;
    align-items: center;
    border-right: 1px solid ${colors.G5};
    border-bottom: 1px solid ${colors.G5};
    font-size: 16px;
    color: ${colors.BK};
    text-align: center;
    padding: 4px 10px;
    line-height: 1.5;

    @media ${(props) => props.theme.mobile} {
      /* height: 43px; */
      font-size: 9px;
      padding: 10px;

      border-right: 0px solid ${colors.G5};
    }

    :nth-child(1) {
      min-width: 140px;

      @media ${(props) => props.theme.mobile} {
        border-right: 1px solid ${colors.G5};
      }
    }

    :nth-child(n + 2):nth-child(-n + 4) {
      min-width: 94px;
    }

    :nth-child(n + 5):nth-child(-n + 7) {
      min-width: 140px;
      /* padding: 0 25px; */
      text-align: center;
    }

    :nth-child(8) {
      /* padding: 0 5px; */
      min-width: 102px;
    }

    :nth-child(9) {
      /* padding: 0 5px; */
      min-width: 99px;
    }

    :nth-child(10) {
      min-width: 113px;
    }

    :nth-child(11) {
      min-width: 151px;
      word-break: break-all;
      white-space: pre-wrap;
      /* padding: 0 25px; */
    }

    :nth-child(12) {
      min-width: 58px;
    }

    :nth-child(13) {
      /* padding: 0 5px; */
      min-width: 100px;
    }
  }

  li:nth-last-child(1) {
    border-right: 0px solid ${colors.W1};
  }
`
